import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5e6c59a9"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "detail-item" }
const _hoisted_2 = { class: "detail-item" }
const _hoisted_3 = { class: "detail-item" }
const _hoisted_4 = { class: "detail-item" }
const _hoisted_5 = { class: "detail-item" }
const _hoisted_6 = { class: "detail-item" }
const _hoisted_7 = { class: "tip" }
const _hoisted_8 = { class: "detail-item" }
const _hoisted_9 = { class: "detail-item" }

import { t } from '@/plugins/i18n'
import { ref, reactive } from 'vue'
import { getJapanTime } from '@/util/common'
import { formatPrice, plusPrice, reducePrice } from '../data_old'
import { isMultiStore } from '@/store'
import { showCurrentUnit } from '@/util/useYan'

export default /*#__PURE__*/_defineComponent({
  props: {
  visible: {
    type: Boolean,
    default: false
  },
  rowName: {
    type: String,
    default: ''
  },
  rowItemDetail: {
    type: Object,
    default: () => ({})
  }
},
  setup(__props) {



return (_ctx: any,_cache: any) => {
  const _component_el_scrollbar = _resolveComponent("el-scrollbar")!

  return (_openBlock(), _createBlock(_component_el_scrollbar, { height: "500px" }, {
    default: _withCtx(() => [
      _createElementVNode("div", null, [
        _createElementVNode("p", _hoisted_1, [
          _createElementVNode("span", null, _toDisplayString(_unref(t)('费用类型')) + "：", 1),
          _createElementVNode("span", null, _toDisplayString(__props.rowName), 1)
        ]),
        _createElementVNode("p", _hoisted_2, [
          _createElementVNode("span", null, _toDisplayString(_unref(t)('国际发货单号')) + "：", 1),
          _createElementVNode("span", null, _toDisplayString(__props.rowItemDetail.deductShipTieredDiffInfoRespDTO?.orderNumber ?? '-'), 1)
        ]),
        _createElementVNode("p", _hoisted_3, [
          _createElementVNode("span", null, _toDisplayString(_unref(t)('国际运单号')) + "：", 1),
          _createElementVNode("span", null, _toDisplayString(__props.rowItemDetail.deductShipTieredDiffInfoRespDTO?.transferNumber ?? '-'), 1)
        ]),
        _createElementVNode("p", _hoisted_4, [
          _createElementVNode("span", null, _toDisplayString(_unref(t)('国际运费重量差补扣')) + "：", 1),
          _createElementVNode("span", null, _toDisplayString(_unref(reducePrice)(__props.rowItemDetail.deductShipTieredDiffInfoRespDTO?.amount)), 1)
        ]),
        _createElementVNode("p", _hoisted_5, [
          _createElementVNode("span", null, _toDisplayString(_unref(t)('我司请求重量')) + "：", 1),
          _createElementVNode("span", null, _toDisplayString(__props.rowItemDetail.deductShipTieredDiffInfoRespDTO?.orderValuationWeight) + "kg(" + _toDisplayString(__props.rowItemDetail.deductShipTieredDiffInfoRespDTO?.orderValuationWeightAmount !== null ?
            __props.rowItemDetail.deductShipTieredDiffInfoRespDTO?.orderValuationWeightAmount + _unref(showCurrentUnit)(_unref(isMultiStore)() && __props.rowItemDetail?.currencyCode === 'KRW'): '-') + ")", 1)
        ]),
        _createElementVNode("p", _hoisted_6, [
          _createElementVNode("span", null, _toDisplayString(_unref(t)('运输公司请求重量')) + "：", 1),
          _createElementVNode("span", null, _toDisplayString(__props.rowItemDetail.deductShipTieredDiffInfoRespDTO?.valuationWeight) + "kg(" + _toDisplayString(__props.rowItemDetail.deductShipTieredDiffInfoRespDTO?.valuationWeightAmount) + _toDisplayString(_unref(showCurrentUnit)(_unref(isMultiStore)()&&__props.rowItemDetail?.currencyCode === 'KRW')) + ")", 1)
        ]),
        _createElementVNode("p", _hoisted_7, _toDisplayString(_unref(t)('※运输公司称重比我司称重的情况下，需要补扣差额。')), 1),
        _createElementVNode("p", _hoisted_8, [
          _createElementVNode("span", null, _toDisplayString(_unref(t)('可用余额')) + "：", 1),
          _createElementVNode("span", null, _toDisplayString(_unref(formatPrice)(__props.rowItemDetail?.afterAvailableAmount)) + _toDisplayString(_unref(showCurrentUnit)(_unref(isMultiStore)()&&__props.rowItemDetail?.currencyCode === 'KRW')), 1)
        ]),
        _createElementVNode("p", _hoisted_9, [
          _createElementVNode("span", null, _toDisplayString(_unref(t)('日期')) + "：", 1),
          _createElementVNode("span", null, _toDisplayString(_unref(getJapanTime)(__props.rowItemDetail?.createTime)), 1)
        ])
      ])
    ]),
    _: 1
  }))
}
}

})